export const groupRoomsContent = `Create video call rooms for groups of people.

## Coming Soon
Group Rooms are currently in development and are coming soon.
Group Rooms are designed for members only.

## Become a Batesky Member
Membership is currently gated with invite-codes, to get an invite send us a DM on the Bluesky app or contact us at [support@batesky.app](mailto:support@batesky.app).
`
